import { Theme } from '@emotion/react';
import Box from '../Box';

interface IDot {
  color: string;
  size?: number;
}

const Dot = ({ color, size = 8 }: IDot) => {
  return (
    <Box
      csx={theme => ({
        borderRadius: 100,
        minWidth: size,
        maxWidth: size,
        minHeight: size,
        maxHeight: size,
        backgroundColor: theme.colors[color as keyof Theme['colors']] || color,
      })}
    />
  );
};

export default Dot;
